<template>
  <div>
      <div class="benefit">
        <a class="prev">
          <img src="../../../../static/img/promotion/netflix-arrow.png" alt="">
          </a>
        <div class="content">
          <div class="box ">
            <div class="item">
              <img src="../../../../static/img/promotion/netflix-benefit1.png" alt="">
              <div class="des">
                {{$t('benefit_item1')}}
              </div>
            </div>
            <div class="item">
              <img src="../../../../static/img/promotion/netflix-benefit2.png" alt="">
              <div class="des">
                {{$t('benefit_item2')}}
              </div>
            </div>
            <div class="item">
              <img src="../../../../static/img/promotion/netflix-benefit3.png" alt="">
              <div class="des">
                {{$t('benefit_item3')}}
              </div>
            </div>
          </div>
        </div>
        <a class="next">
          <img src="../../../../static/img/promotion/netflix-arrow.png" alt="">
        </a>
      </div>
  </div>
</template>

<script>
import { loadBenefit } from './Benefit.js'
import locales from './lang'

export default {
  locales,
  methods: {
  },
  mounted() {
    loadBenefit()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import '../../../assets/scss/common.scss';
  
  .benefit{
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .content{
      max-width: 1200px;
      overflow: hidden;
      .box{
        padding: 1px;
        overflow: hidden;
        transition: all 0.5s;
        left: 0;
        position: relative;
        .item{
          width: 465px;
          height: 408px;
          float: left;
          background-color: #fff;
          box-shadow: 0 0 5px 1px #e3e3e3;
          margin-left: 20px;
          img{
            width: 100%;
          }
          .des{
            text-align: center;
            line-height: 88px;
          }
        }
        .item:first-child{
          margin-left: 0px;
        }
      }
    }
    .next{
      margin: 0 10px;
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
    .prev{
      margin: 0 10px;
      img{
        transform: rotate(180deg);
        cursor: pointer;
      }
    }
  }

  @media screen and (max-width: 768px) {

    .benefit{
      position: relative;
      
      .content{
        
        .box{
          width: 100% !important;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .item{
            height: 280px;
            width: 300px;
            float: none;
            margin: 10px 0;
          }
        }
      }
      .next{
        display: none;
      }
      .prev{
        display: none;
        img{
          transform: rotate(180deg);
          cursor: pointer;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Benefit.vue?15e601d2